import React from "react";
import {PaperSessionHeadPanel} from "./PaperSessionHeadPanel";

export class BasicPaperSession extends React.Component {
    constructor(props) {
        super(props);

        this.handleDragStart = this.handleDragStart.bind(this)
    }

    countKeywords(papers) {
        let counter = {};
        let keywords = {};
        for (let paper of papers) {
            for (let keyword of paper.keywords) {
                if (!counter.hasOwnProperty(keyword.code)) counter[keyword.code] = 0;
                if (!keywords.hasOwnProperty(keyword.code)) keywords[keyword.code] = keyword;
                counter[keyword.code] += 1;
            }
        }

        /*  Arrange counts to be a list of objects*/
        let counter_list = [];
        for (let code in counter) counter_list.push({"keyword": keywords[code], "count": counter[code]});

        /* Sort objects by count value */
        counter_list.sort(function (a, b) {
            if (a.count > b.count) return -1;
            else if (a.count < b.count) return 1;
            // Case when count is equal, sort alphabetically by keyword name
            else {
                if (a.keyword.code > b.keyword.code) return 1;
                else if (a.keyword.code < b.keyword.code) return -1;
                else return 0;
            }
        });

        return counter_list;
    }

    handleDragStart(event) {
        const data = {source: 'paperSession', session: this.props.paperSession};
        event.dataTransfer.setData("text/plain", JSON.stringify(data));
    }

    render() {
        const {paperSession} = this.props;
        const {papers, id, data} = paperSession;

        const keywordCounts = this.countKeywords(papers).slice(0, 4);

        const paperSummary =
            <div className="paperssummary-calendar"
                 style={{display: "block", backgroundColor: data.panel_color}}>
                {papers.length} paper(s) in this session
            </div>;

        return (
            <div className="panel panelsession dragthis" draggable="true" onDragStart={this.handleDragStart}>
                <div id={"s" + id} className="session" style={{display: "block"}}>
                    <PaperSessionHeadPanel
                        handleClick={this.props.handleShowModal}
                        data={data}
                        sessionColor={data.panel_color}
                        keywordCounts={keywordCounts}
                        paperCount={papers.length}
                        showPaperCount={false}
                        buttonClassName="pull-right glyphicon glyphicon-zoom-in pointer openmodal-showsession"
                        sessionNameClassName="sessionname-calendar"/>
                    {paperSummary}
                </div>
            </div>
        )
    }
}
